var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconsLocationOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003A5D",
    d: "M12 22c-4.667-4.924-7-9.183-7-12.778C5 5.08 8.134 2 12 2s7 3.08 7 7.222c0 3.595-2.333 7.854-7 12.778zm5-12.778C17 6.23 14.806 4 12 4S7 6.23 7 9.222c0 2.622 1.634 5.917 5 9.803 3.366-3.886 5-7.18 5-9.803zM12 11a2 2 0 11-.001-3.999A2 2 0 0112 11z"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgZmlsbC1ydWxlPSJub256ZXJvIj4KICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNMCAwSDI0VjI0SDB6Ii8+CiAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjMDAzQTVEIiBkPSJNMTIgMjJjLTQuNjY3LTQuOTI0LTctOS4xODMtNy0xMi43NzhDNSA1LjA4IDguMTM0IDIgMTIgMnM3IDMuMDggNyA3LjIyMmMwIDMuNTk1LTIuMzMzIDcuODU0LTcgMTIuNzc4em01LTEyLjc3OEMxNyA2LjIzIDE0LjgwNiA0IDEyIDRTNyA2LjIzIDcgOS4yMjJjMCAyLjYyMiAxLjYzNCA1LjkxNyA1IDkuODAzIDMuMzY2LTMuODg2IDUtNy4xOCA1LTkuODAzek0xMiAxMWMtMS4xMDUgMC0yLS44OTUtMi0ycy44OTUtMiAyLTIgMiAuODk1IDIgMi0uODk1IDItMiAyeiIvPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgIconsLocationOutlined as ReactComponent };